import { TabWrap } from 'sections/TabWrap';

import { useData } from './Data.hooks';

export function Data(): React.ReactElement {
  const { sections } = useData();

  return <TabWrap sections={sections} />;
}
